import {useAppDataStore} from "@/mobx/appDataStore.jsx";
import {Fragment, useEffect, useState} from 'react'
import {NavLink, Outlet, useLocation} from "react-router-dom";
import logoTigo from "assets/logotigo.png"
import logoNova from "assets/logo-poli-inverted-small.png"
import {Disclosure, Menu, Transition} from '@headlessui/react'
import {Bars3Icon, BellIcon, XMarkIcon} from '@heroicons/react/24/outline'


const navigation = [
  {name: 'Dashboard', href: '/app/dashboard', menu: 'main', scope: null}, // Disponible para todos
  {name: 'Tigo Gestión', href: '/app/providers', menu: 'main', scope: 'tigogestion'},
  {name: 'Disney+', href: '/app/disney', menu: 'main', scope: 'entertainment'},
  {name: 'SNR', href: '/app/snr', menu: 'main', scope: 'snr'},
  {name: 'Previsora', href: '/app/snr', menu: 'main', scope: 'previsora'},
  {name: 'Cambiar Contraseña', href: '/app/config', menu: 'user'},
  {name: 'Configuración API', href: '/app/api', menu: 'user'},
  {name: 'Gestión de Usuarios', href: '/app/admin/users', menu: 'main', requiredScope: 'master'},
  {name: 'Reportes de Consignación', href: '/app/admin/balance', menu: 'main', requiredScope: 'master'},
  {name: 'Historial de ventas', href: '/app/admin/sales', menu: 'main', requiredScope: 'master'},
  {name: 'Gestión de Tokens Disney', href: '/app/admin/disney-tokens', menu: 'main', requiredScope: 'master'},
  {name: 'Gestión de Tokens Nuplin', href: '/app/admin/nuplin-tokens', menu: 'main', requiredScope: 'master'},
  {name: 'Configuración del Sistema', href: '/app/admin/config', menu: 'main', requiredScope: 'master'},
  {name: 'Conciliaciones', href: '/app/admin/reconciliations', menu: 'main', requiredScope: 'master'},
  {name: 'Cerrar sesión', href: '/app/logout', menu: 'user'},
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

function userHasScope(user, requiredScope) {
  if (!requiredScope) return true
  const userScopes = user?.scopes || []
  return Array.isArray(userScopes) && userScopes.includes(requiredScope)
}

function canAccessMenu(user, menuItem) {
  // Si el menú requiere un scope específico (requiredScope o scope)
  const requiredScope = menuItem.requiredScope || menuItem.scope
  return userHasScope(user, requiredScope)
}

export default function Layout(args) {
  const location = useLocation()
  const {pathname} = location
  const appDataStore = useAppDataStore()
  const {user} = appDataStore

  const [currentNavigation, setCurrentNavigation] = useState(
    navigation.find(({href}) => pathname === href || pathname.startsWith(href + '/'))
  )

  // Actualizar currentNavigation cuando cambie la ruta
  useEffect(() => {
    setCurrentNavigation(
      navigation.find(({href}) => pathname === href || pathname.startsWith(href + '/'))
    )
  }, [pathname])

  return (
    <>
      <div className="min-h-full">
        <Disclosure as="nav" className="bg-gray-800 w-full">
          {({open}) => (
            <>
              <div className="px-4 sm:px-6 lg:px-8">
                <div className="flex h-16 items-center justify-between">
                  <div className="flex items-center">
                    <div className="flex-shrink-0">
                      <img
                        className="h-8 inline"
                        src={logoNova}
                        alt="Nova MLVM"
                      />

                    </div>
                    <div className="hidden md:block">
                      <div className="ml-10 flex items-baseline space-x-4">
                        {navigation.filter((item) => item.menu === 'main' && canAccessMenu(user, item)).map((item) => (
                          <NavLink
                            onClick={() => setCurrentNavigation(item)}
                            key={item.name}
                            to={item.href}
                            className={classNames(
                              item.href === currentNavigation.href
                                ? 'bg-gray-900 text-white'
                                : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                              'rounded-md px-3 py-2 text-sm font-medium'
                            )}
                            aria-current={item.href === currentNavigation.href ? 'page' : undefined}
                          >
                            {item.name}
                          </NavLink>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="hidden md:block">
                    <div className="ml-4 flex items-center md:ml-6">


                      {/* Profile dropdown */}
                      <Menu as="div" className="relative ml-3">
                        <div>
                          <Menu.Button
                            className="relative flex max-w-xs items-center rounded-full  text-lg focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                            <span className="absolute -inset-1.5"/>
                            <span className="sr-only">Open user menu</span>
                            <span className="text-white font-bold">{user.name}</span>
                          </Menu.Button>
                        </div>
                        <Transition
                          as={Fragment}
                          enter="transition ease-out duration-100"
                          enterFrom="transform opacity-0 scale-95"
                          enterTo="transform opacity-100 scale-100"
                          leave="transition ease-in duration-75"
                          leaveFrom="transform opacity-100 scale-100"
                          leaveTo="transform opacity-0 scale-95"
                        >
                          <Menu.Items
                            className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                            {navigation.filter((item) => item.menu === 'user' && canAccessMenu(user, item)).map((item) => (
                              <Menu.Item key={item.name}>
                                {({active}) => (
                                  <NavLink
                                    onClick={() => setCurrentNavigation(item)}
                                    to={item.href}
                                    className={classNames(
                                      active ? 'bg-gray-100' : '',
                                      'block px-4 py-2 text-sm text-gray-700'
                                    )}
                                  >
                                    {item.name}
                                  </NavLink>
                                )}
                              </Menu.Item>
                            ))}
                          </Menu.Items>
                        </Transition>
                      </Menu>
                    </div>
                  </div>
                  <div className="-mr-2 flex md:hidden">
                    {/* Mobile menu button */}
                    <Disclosure.Button
                      className="relative inline-flex items-center justify-center rounded-md bg-gray-800 p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                      <span className="absolute -inset-0.5"/>
                      <span className="sr-only">Open main menu</span>
                      {open ? (
                        <XMarkIcon className="block h-6 w-6" aria-hidden="true"/>
                      ) : (
                        <Bars3Icon className="block h-6 w-6" aria-hidden="true"/>
                      )}
                    </Disclosure.Button>
                  </div>
                </div>
              </div>

              <Disclosure.Panel className="md:hidden">
                <div className="space-y-1 px-2 pb-3 pt-2 sm:px-3">
                  {navigation.filter((item) => item.menu === 'main' && canAccessMenu(user, item)).map((item) => (
                    <Disclosure.Button
                      key={item.name}
                      as="a"
                      href={item.href}
                      className={classNames(
                        item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                        'block rounded-md px-3 py-2 text-base font-medium'
                      )}
                      aria-current={item.current ? 'page' : undefined}
                    >
                      {item.name}
                    </Disclosure.Button>
                  ))}
                </div>
                <div className="border-t border-gray-700 pb-3 pt-4">
                  <div className="flex items-center px-2">
                    <div className="ml-3">
                      <div className="text-base font-medium leading-none text-white">{user.name}</div>
                      <div className="text-sm font-medium leading-none text-gray-400">{user.email}</div>
                    </div>

                  </div>
                  <div className="mt-3 space-y-1 px-2">
                    {navigation.filter((item) => item.menu === 'user' && canAccessMenu(user, item)).map((item) => (
                      <Disclosure.Button
                        key={item.name}
                        as="a"
                        href={item.href}
                        className="block rounded-md px-3 py-2 text-base font-medium text-gray-400 hover:bg-gray-700 hover:text-white"
                      >
                        {item.name}
                      </Disclosure.Button>
                    ))}
                  </div>
                </div>
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>

        <header className="bg-white shadow w-full">
          <div className="px-4 py-6 sm:px-6 lg:px-8">
            <h1 className="text-3xl font-bold tracking-tight text-gray-900">{currentNavigation.name}</h1>
          </div>
        </header>
        <main>
          <div className="mx-auto max-w-8xl py-6 sm:px-6 lg:px-4">
            <Outlet/>
          </div>
        </main>
      </div>
    </>
  )
}

